import Vue, { PropType } from 'vue';

import { 勘定科目ListItemResponse } from '@/openapi/user';

export default Vue.extend({
  name: 'C勘定科目Select',

  props: {
    value: {
      type: String,
      default: '',
    },
    勘定科目s: {
      type: Array as PropType<勘定科目ListItemResponse[]>,
      default: () => [],
    },
    selected: {
      type: Object as PropType<勘定科目ListItemResponse>,
    },
  },

  computed: {
    filtered勘定科目s(): 勘定科目ListItemResponse[] {
      if (this.value.length === 0) return this.勘定科目s;

      // '費'を除く一文字でも一致していれば選択肢に反映
      const escaped = this.value.replaceAll('費', '').replaceAll(/[\\\-^[\]/]/g, '\\$&');
      return this.勘定科目s.filter((勘) => 勘.c勘定科目.match(new RegExp('[' + escaped + ']')));
    },
    selected勘定科目: {
      get(): 勘定科目ListItemResponse | null {
        return this.selected;
      },
      set(v: 勘定科目ListItemResponse): void {
        this.$emit('update:selected', v);
        this.$emit('change', v);
      },
    },
  },

  methods: {
    async input(value: string): Promise<void> {
      this.$emit('update:value', value);
      await this.$nextTick(); // emitで伝達したthis.valueの更新待ち（filtered勘定科目sで利用）

      const find勘定科目 = this.filtered勘定科目s.find((勘) => 勘.c勘定科目 === value);
      if (find勘定科目 !== undefined) {
        // 入力値と一致する候補がある場合は選択状態にする
        this.selected勘定科目 = find勘定科目;
      } else {
        // 選択状態を外す
        this.selected勘定科目 = null;
      }
    },
  },
});
